/* IntelApps — Hero Section */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Arrow } from './Header.js';
import { useI18n } from '../i18n.js';

function HeroTitle({ html }) {
  // eslint-disable-next-line react/no-danger
  return <h1 dangerouslySetInnerHTML={{ __html: html }} />;
}

HeroTitle.propTypes = {
  html: PropTypes.string.isRequired,
};

const R_PROJECTS = {
  doordash: '/assets/portfolio/doordash.png',
  ankerkrut: '/assets/portfolio/ankerkrut.png',
  oanda: '/assets/portfolio/oanda.png',
  amenity: '/assets/portfolio/amenity.png',
  aiagent: '/assets/portfolio/aiagent.png',
  scifi: '/assets/portfolio/scifi.png',
  promod: '/assets/portfolio/promod.png',
  rollei: '/assets/portfolio/rollei.png',
  shein: '/assets/portfolio/shein.png',
  studioai: '/assets/portfolio/studioai.png',
  easemate: '/assets/portfolio/easemate.png',
};

export default function HomeHero() {
  const { t } = useI18n();
  const getAccent = () => {
    if (typeof window !== 'undefined') {
      return getComputedStyle(document.documentElement).getPropertyValue('--accent').trim() || '#F97316';
    }
    return '#F97316';
  };
  const accent = getAccent();

  return (
    <section className="hero">
      <div className="container hero-inner">
        <div>
          <div className="hero-tag">
            <span className="pill">2026</span>
            <span>{t.hero.studioInfo}</span>
          </div>
          <HeroTitle html={t.hero.title} />
          <p className="hero-lede">
            {t.hero.description}
          </p>
          <div className="hero-cta">
            <Link to="/discuss-project" className="btn btn-accent btn-arrow">
              {t.hero.cta.primary} <Arrow size={14} />
            </Link>
            <Link to="/work" className="btn btn-ghost">{t.hero.cta.secondary}</Link>
            <span className="hero-meta">{t.hero.cta.responseTime}</span>
          </div>
          <div className="badges">
            <span className="badge">{t.hero.badges.soc2}</span>
            <span className="badge">{t.hero.badges.iso}</span>
            <span className="badge">{t.hero.badges.gdpr}</span>
            <span className="badge">{t.hero.badges.aws}</span>
          </div>
        </div>

        <div className="hero-card">
          <div className="hero-card-head">
            <span className="hero-card-tag">{t.hero.metrics.tag}</span>
            <span className="hero-card-pill">{t.hero.metrics.pill}</span>
          </div>
          <div className="hero-card-stats">
            <div className="hero-card-stat"><div className="hero-card-stat-num">68<span className="unit">+</span></div><div className="hero-card-stat-label">{t.hero.metrics.productsShipped}</div></div>
            <div className="hero-card-stat"><div className="hero-card-stat-num">98<span className="unit">%</span></div><div className="hero-card-stat-label">{t.hero.metrics.onTimeDelivery}</div></div>
            <div className="hero-card-stat"><div className="hero-card-stat-num">$24<span className="unit">M</span></div><div className="hero-card-stat-label">{t.hero.metrics.clientRevenue}</div></div>
            <div className="hero-card-stat"><div className="hero-card-stat-num">4.9<span className="unit">/5</span></div><div className="hero-card-stat-label">{t.hero.metrics.avgRating}</div></div>
          </div>
          <div className="hero-spark">
            <svg viewBox="0 0 320 56" preserveAspectRatio="none">
              <path d="M0,40 L20,38 L40,42 L60,32 L80,30 L100,28 L120,22 L140,26 L160,18 L180,16 L200,12 L220,14 L240,8 L260,10 L280,4 L300,6 L320,2" fill="none" stroke={accent} strokeWidth="2" />
            </svg>
          </div>
          <div
            style={{
              marginTop: 14,
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 11,
              color: 'var(--ink-4)',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <span>{t.hero.metrics.throughput}</span>
            <span style={{ color: 'var(--emerald)' }}>↑ 38%</span>
          </div>
        </div>
      </div>

      <div className="container logos">
        <div className="logos-inner">
          <span className="logos-label">{t.hero.trusted.label}</span>
          <div className="logos-row">
            <span className="logo-item">◆ Surveyor</span>
            <span className="logo-item">▲ Marley Co</span>
            <span className="logo-item">◐ Shultan</span>
            <span className="logo-item">◇ Staymenity</span>
            <span className="logo-item">⬢ Winify</span>
            <span className="logo-item">⬡ Nobleblocks</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export { R_PROJECTS };
